import React from 'react';
import { Dropdown, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCheck, faCopy } from '@fortawesome/free-solid-svg-icons';
import './LanguageSelector.css';

const LanguageSelector = ({ currentLanguage, availableLanguages, onLanguageChange, showBadge = true, onCopyFromLanguage, showCopyFromLanguage = false }) => {
    const getCurrentLanguageInfo = () => {
        return availableLanguages.find(lang => lang.code === currentLanguage) || availableLanguages[0];
    };

    const currentLangInfo = getCurrentLanguageInfo();

    return (
        <div className="language-selector d-flex align-items-center flex-wrap">
            <Dropdown align="end">
                <Dropdown.Toggle 
                    variant="outline-primary" 
                    id="language-dropdown"
                    className="d-flex align-items-center gap-2 language-selector-toggle"
                >
                    <FontAwesomeIcon icon={faGlobe} />
                    <span className="d-none d-md-inline">{currentLangInfo?.name}</span>
                    <span className="language-code">{currentLangInfo?.code.toUpperCase()}</span>
                    {showBadge && (
                        <Badge bg="info" className="ms-1">
                            {availableLanguages?.length}
                        </Badge>
                    )}
                </Dropdown.Toggle>

                <Dropdown.Menu className="language-dropdown-menu">
                    <Dropdown.Header className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon={faGlobe} />
                        <span>Select Language</span>
                    </Dropdown.Header>
                    <Dropdown.Divider />
                    
                    {availableLanguages.map((language) => (
                        <Dropdown.Item
                            key={language.code}
                            onClick={() => onLanguageChange(language.code)}
                            className={`language-item ${currentLanguage === language.code ? 'active' : ''}`}
                        >
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <div className="d-flex align-items-center gap-3">
                                    <span className="language-flag">{language.code}</span>
                                    <div>
                                        <div className="language-name">{language.name}</div>
                                        <small className="language-native text-muted">
                                            {language.name}
                                        </small>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <span className="language-code-small">{language.code.toUpperCase()}</span>
                                    {currentLanguage === language.code && (
                                        <FontAwesomeIcon icon={faCheck} className="text-success" />
                                    )}
                                </div>
                            </div>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            
            {showCopyFromLanguage && (
                <Dropdown align="end" className="ms-2 me-2">
                    <Dropdown.Toggle
                        variant="outline-secondary" 
                        size="sm"
                        id="copy-from-dropdown"
                        className="d-flex align-items-center gap-2 copy-from-toggle"
                    >
                        <span>Copy from <FontAwesomeIcon icon={faCopy} /></span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="copy-from-dropdown-menu">
                        <Dropdown.Header className="d-flex align-items-center gap-2">
                            <FontAwesomeIcon icon={faGlobe} />
                            <span>Copy from Language</span>
                        </Dropdown.Header>
                        <Dropdown.Divider />
                        
                        {availableLanguages.map((language) => (
                            <Dropdown.Item
                                key={language.code}
                                onClick={() => onCopyFromLanguage(language.code)}
                                className="copy-from-item"
                            >
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    <div className="d-flex align-items-center gap-3">
                                        <span className="language-flag">{language.code}</span>
                                        <div>
                                            <div className="language-name">{language.name}</div>
                                            <small className="language-native text-muted">
                                                {language.name}
                                            </small>
                                        </div>
                                    </div>
                                    <span className="language-code-small">{language.code.toUpperCase()}</span>
                                </div>
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </div>
    );
};

export default LanguageSelector;